export const ENV = {
  apiUrl: String(process.env.REACT_APP_API_URL)
  // apiUrl: String(process.env.REACT_APP_API_URL_DEV)
};
